module.exports = __webpack_public_path__ + "static/media/apple-ios.bbb06c48.png";